<template>
  <div class="grid-wrapper">
    <div class="filter">
      <sui-button compact @click="requestRefresh">Refresh</sui-button>
    </div>
    <simple-table :data="data" :columns="stColumns" :stretch="true" :show-row-numbers="true" @select="stSelectHandler" :selectable="true" :num-rows="999"/>
  </div>
</template>

<script>
  import SimpleTable from "../simple-table/SimpleTable"

    export default {
      name: "CustomerManagementList",
      components: {SimpleTable},
      props: ["data", "selectedId"],
      data: function() {
        return {
          stColumns: [
            {header: "id", field: "ID", format: "number"},
            {header: "Full Name", field: "Name"},
            {header: "E-mail", field: "Email"},
            {header: "UID", field: "UID"},
            {header: "Clients", field: "Clients", format: "listCount"},
            {header: "Devices", field: "Devices", format: "listCount"},
          ],
        }
      },

      methods: {
        requestRefresh() {
          this.$emit('refresh')
        },
        stSelectHandler(item) {
          this.$emit("select", item)
        },
      }
    }
</script>

<style scoped lang="less">
  .filter {
    background: #F0F0F0;
    > * {
      margin: 5pt 5pt;
    }
  }
  .device-list {
    box-sizing: border-box;
    overflow-x: auto;
    width: 100%;
  }
</style>
